import { useIsMobile } from "@/hooks/useIsMobile";
import React, { useRef, useState, TouchEvent } from "react";
import { Modal } from "@/utils/bootstrap";

interface props {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
  style?: React.CSSProperties;
  contentClassName?: string;
}
const PopUp: React.FC<props> = ({
  children,
  isOpen,
  onClose,
  fullScreen,
  style = {},
  contentClassName: contentClassNameProp,
}) => {
  const mobile = useIsMobile();
  const [touchStartY, setTouchStartY] = useState<number | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  const onTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    if (!mobile || fullScreen) return;
    
    // Check if any element from target up to scrollRef has scrolled down
    let node = e.target as HTMLElement | null;
    let isNestedScrolled = false;
    while (node && node !== scrollRef.current) {
      if (node.scrollTop > 0) {
        isNestedScrolled = true;
        break;
      }
      node = node.parentElement;
    }
    
    const isAtTop = scrollRef.current ? scrollRef.current.scrollTop <= 0 && !isNestedScrolled : !isNestedScrolled;
    
    if (isAtTop) {
      setTouchStartY(e.touches[0].clientY);
    } else {
      setTouchStartY(null);
    }
  };

  const onTouchMove = (e: TouchEvent<HTMLDivElement>) => {
    if (!mobile || fullScreen || touchStartY === null) return;
    
    const currentY = e.touches[0].clientY;
    const distance = currentY - touchStartY;
    
    let node = e.target as HTMLElement | null;
    let isNestedScrolled = false;
    while (node && node !== scrollRef.current) {
      if (node.scrollTop > 0) {
        isNestedScrolled = true;
        break;
      }
      node = node.parentElement;
    }

    const isAtTop = scrollRef.current ? scrollRef.current.scrollTop <= 0 && !isNestedScrolled : !isNestedScrolled;

    if (distance > 150 && isAtTop) {
      if (onClose) onClose();
      setTouchStartY(null);
    }
  };

  const onTouchEnd = () => {
    setTouchStartY(null);
  };

  // const mCLass = mobile ? "w-100" : "product-popup-container";
  const modalClassName = mobile
    ? fullScreen
      ? ""
      : "modal-as-swipeable-drawer drawer up-align"
    : "";
  const dialogClassName = !mobile ? "messagebox-dialog" : "";
  const contentClassName = mobile
    ? `dialog-swipeable-drawer ${contentClassNameProp}`
    : `pop-up-contents-reciving ${contentClassNameProp}`;

  return (
    <Modal
      centered={!mobile}
      fullscreen={fullScreen ? fullScreen : undefined}
      show={isOpen}
      onHide={onClose}
      className={modalClassName}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
      style={mobile ? { zIndex: 9999, padding: 0, ...style } : { ...style }}
    >
      <div
        ref={scrollRef}
        className="w-100"
        style={
          mobile ? { height: "90vh", overflow: "auto", paddingBottom: 25 } : {}
        }
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {children}
      </div>
    </Modal>
  );
};
export default PopUp;
